import React from 'react';
import { useCart } from 'react-use-cart';

import Dropdown from 'antd/lib/dropdown';
import 'antd/lib/dropdown/style/index.css';
import 'antd/lib/style/index.css';

import LinkWithPrevLocation from '@common/react/components/UI/LinkWithPrevLocation/LinkWithPrevLocation';

import ShoppingCartInformation from '@app/components/UI/ShoppingCartInformation/ShoppingCartInformation';

const ShoppingCartDropdown: React.FC = () => {
	const [isInitialized, setIsInitialized] = React.useState<boolean>(false);
	const { totalItems } = useCart();
	
	React.useEffect(() => {
		setIsInitialized(true);
	}, []);
	
	const totalCount = isInitialized ? totalItems : 0;
	
	return <div className="shopping-cart">
		<Dropdown
			overlayClassName="shopping-cart__dropdown"
			overlay={
			<ShoppingCartInformation 
				checkout={
					<LinkWithPrevLocation to="/ordering">
						Check out
					</LinkWithPrevLocation>
				}
			/>}
		>
			<LinkWithPrevLocation to="/shopping-cart">
				<div className="shopping-cart__icon">
					<i className="fa fa-shopping-cart" title="Shopping Cart"/>
					<div className="total-items" hidden={totalCount === 0}>
						{totalCount}
					</div>
				</div>
			</LinkWithPrevLocation>
		</Dropdown>
	</div>;
};

export default ShoppingCartDropdown;
